import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import moment from "moment";
import { interval } from "rxjs";
import { InspectionConstantsService } from "../../../inspection/Services/inspection-constants.service";
import { MasterscreenService } from "../../../masterscreen/services/masterscreen.service";
import { Login } from "../../../observation/model/login.model";
import { DashboardFilter } from "../../../shared/models/dashboardFilter.model";
import { BaseService } from "../../../shared/services/base.service";
import { NotificationsService } from "../../../shared/services/notification.service";
import { FileUtility } from "../../../shared/utility/file.utility";
import { CheckInCheckOutDetails } from "../../model/masterrequest.model";
import { PersononboardConstantsService } from "../../services/persononboard-constants.service";
import { PersononboardService } from "../../services/persononboard.service";
import { ActivatedRoute } from "@angular/router";
import { coerceNumberProperty } from "@angular/cdk/coercion";

@Component({
  selector: "ara-pob-list-dashboard",
  templateUrl: "./pob-list-dashboard.component.html",
  styleUrls: ["./pob-list-dashboard.component.css"]
})
export class PobListDashboardComponent implements OnInit {
  routesFlag: { routeName: string; routeURL: string; isClickable: boolean; }[];
  reportRoutes: { routeName: string; routeURL: string; isClickable: boolean; }[];
  displayPopUp: boolean = false;
  login: Login;
  company: any = {};
  display: boolean;
  locations: any[] = [];
  errorDetails: string;
  alertType: string;
  loggedInUserJSON: any;
  companyDetailsResponse: any[];
  companyList: any[] = [];
  defaultLocation: string;
  defaultCompany: string;
  selectedCompany: any[];
  selectedLocation: number[];
  selectedCheckinLocation: number[];
  pobListData: any = [];
  checkInCheckOutDetails: CheckInCheckOutDetails;
  passRequestOverviewFilter: DashboardFilter;
  hideFilter: boolean = false;
  locationDetails: any[];
  searchModified: boolean = false;
  hideSort: boolean = false;
  searchText: string = "";
  pageSize: number = 1;
  columnList: any;
  jsonString: any;
  isExportToExcel: boolean = false;
  exportToExcelData: any;
  showPagination: boolean;
  noRecordsMsg: string;
  checkInCheckOutData: CheckInCheckOutDetails[];
  passRequestFromDate: Date;
  expiryDate: Date;
  unitList: any[];
  selectedUnit: any[] = [];
  itemPerPage: number = 50;
  rowCount: number = 100;
  successDetails: string;
  confirmMessage: string;
  isPassRequestsChecked: boolean = true;
  checked: any;
  statuses: any = [];
  selectedStatus: any = [];
  isOnline: boolean = false;
  offlineRoutes: any[] = [];
  repeatCheck: any;
  window = window;
  selectedPassType: number[] = [];
  passTypes: any[] = [];
  disableExport: boolean = false;
  dateFormatDDMMYYYY = '';
  observationFromDate: Date =new Date( new Date().setHours(0, 0, 0, 0));
  observationToDate: Date =new Date( new Date().setHours(23, 59, 59, 0));
  currentDate = new Date();
  ResetOrDone : boolean = false;
  PageLoad : boolean = false;
  RedirectFromDashboard : number = 0;

  constructor(
    private baseService: BaseService,
    private masterscreenService: MasterscreenService,
    private pobservice: PersononboardService,
    private pobServices: PersononboardService,
    private notificationsService: NotificationsService,
    private translate: TranslateService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.checkOnlineStatus();
    this.checkInCheckOutDetails = new CheckInCheckOutDetails();
    this.passRequestOverviewFilter = new DashboardFilter();
    this.selectedCompany = [];
    this.selectedLocation = [];
    this.selectedCheckinLocation = [];
    this.unitList = [];
    this.checkInCheckOutData = [];
    this.isPassRequestsChecked = false;
    this.passTypes.push({ label: 'Staff', value: 1 });
    this.passTypes.push({ label: 'Contractor', value: 2 });
    this.selectedPassType = [1, 2];
    this.route.params.subscribe(params => {
      this.RedirectFromDashboard = isNaN(params["D"])? 0 :coerceNumberProperty(params["D"]);
    });
    if (navigator.onLine) {
      const routes = JSON.stringify(
        PersononboardConstantsService.PersonOnBoardUrl.InnerRoutes
      );
      this.routesFlag = JSON.parse(routes);
      const independentPermissions = JSON.parse(
        this.baseService.getItemFromSession("UserIndependentPermissions")
      );
      if (
        !independentPermissions.POB_Contractor_Add &&
        !independentPermissions.POB_Contractor_Add_Unit &&
        !independentPermissions.POB_Staff_Add &&
        !independentPermissions.POB_Staff_Add_Unit &&
        !independentPermissions.POB_Admin &&
        !independentPermissions.POB_Admin_Unit
      ) {
        for (let index = 0; index < this.routesFlag.length; index++) {
          if (this.routesFlag[index].routeName === "New Pass") {
            this.routesFlag.splice(index, 1);
            break;
          }
        }
      }
      this.baseService.setItemInSession(
        "offlineRoutes",
        JSON.stringify(this.routesFlag)
      );
      this.reportRoutes =
        PersononboardConstantsService.PersonOnBoardUrl.ReportRoutes;
      this.login = new Login();
      const loggedInUser = this.baseService.getItemFromSession("loggedInUser");
      this.loggedInUserJSON = JSON.parse(loggedInUser);
      this.login.CompanyId = this.loggedInUserJSON.Company.CompanyId;
      this.login.ID = this.loggedInUserJSON.UserId;
      this.statuses.push({
        label: "In",
        value: 1
      });
      this.statuses.push({
        label: "Out",
        value: 2
      });
      this.baseService.setItemInSession(
        "offlineStatus",
        JSON.stringify(this.statuses)
      );
      this.selectedStatus.push(1);
      this.selectedStatus.push(2);
      this.PageLoad = true;
      this.getUnits();
    } else {
      const routes = JSON.stringify(
        PersononboardConstantsService.PersonOnBoardUrl.OfflineRoutes
      );
      this.routesFlag = JSON.parse(routes);
      this.baseService.setItemInSession(
        "offlineSplicedRoutes",
        JSON.stringify(this.routesFlag)
      );
      this.getOfflineData();
    }
    this.baseService.translatorListener.subscribe(data => {
      this.translate.use(data);
    });
  }
  checkOnlineStatus() {
    this.repeatCheck = interval(1);
    this.repeatCheck.subscribe(val => {
      if (navigator.onLine) {
        this.isOnline = true;
      } else {
        this.isOnline = false;
      }
    });
    if (this.isOnline) {
      this.routesFlag = JSON.parse(
        this.baseService.getItemFromSession("offlineRoutes")
      );
    } else {
      this.routesFlag = JSON.parse(
        this.baseService.getItemFromSession("offlineSplicedRoutes")
      );
    }
  }
  getOfflineData() {
    let offlineUnits = JSON.parse(
      this.baseService.getItemFromSession("offlineUnits")
    );
    this.setOfflineUnits(offlineUnits);
    let offlineLocations = JSON.parse(
      this.baseService.getItemFromSession("offlineLocations")
    );
    this.setOfflineLocations(offlineLocations);
    let offlinestatuses = JSON.parse(
      this.baseService.getItemFromSession("offlineStatus")
    );
    this.setOfflineStatuses(offlinestatuses);
    let offlinePobListOverviewData = JSON.parse(
      this.baseService.getItemFromSession("offlinePobListData")
    );
    this.offlineRoutes = JSON.parse(
      this.baseService.getItemFromSession("offlineSplicedRoutes")
    );
    if (offlinePobListOverviewData !== null) {
      this.pobListData = offlinePobListOverviewData;
    }
    if (this.offlineRoutes !== null) {
      this.routesFlag = this.offlineRoutes;
    }
    this.disableExport = false;
  }
  setOfflineStatuses(offlinestatuses) {
    if (offlinestatuses !== null) {
      this.statuses = offlinestatuses;
      offlinestatuses.forEach(element => {
        this.selectedStatus.push(element);
      });
    }
  }

  setOfflineLocations(offlineLocations) {
    if (offlineLocations !== null) {
      this.locationDetails.forEach(location => {
        location["checked"] = true;
        this.locations.push({
          label: location.LocationName,
          value: location.LocationId
        });
        this.selectedLocation.push(location.LocationId);
      });
    }
  }
  setOfflineUnits(offlineUnits) {
    if (offlineUnits !== null) {
      this.unitList = [];
      offlineUnits.forEach(unit => {
        unit.checked = true;
        this.unitList.push({
          label: unit.UnitName,
          value: unit.UnitId
        });
        this.selectedUnit.push(unit.UnitId);
      });
    }
  }

  // method to get the location
  getLocation() {
    this.masterscreenService.getLocationDetails(
      null,
      this.callbackMethodForGetLocationDetails.bind(this)
    );
  }

  // call back method of get location
  callbackMethodForGetLocationDetails(response) {
    if (response) {
      this.locations = [];
      this.locationDetails = response;
      this.baseService.setItemInSession(
        "offlineLocations",
        JSON.stringify(this.locationDetails)
      );
      this.locationDetails.forEach(location => {
        location["checked"] = true;
        this.locations.push({
          label: location.LocationName,
          value: location.LocationId
        });
      });
      this.resetValue(false);
    }
  }

  showCheckInDetails(passRequestData) {
    this.checkInCheckOutData = passRequestData.CheckInCheckOutDetails;
    this.checkInCheckOutData.forEach(checkInDetails => {
      if (checkInDetails.CheckInTime !== null) {
        checkInDetails.CheckInTime = new Date(
          moment(moment.utc(checkInDetails.CheckInTime).local()).format(
            "MMM D, YYYY LT"
          )
        );
      }
      if (checkInDetails.CheckOutTime !== null) {
        checkInDetails.CheckOutTime = new Date(
          moment(moment.utc(checkInDetails.CheckOutTime).local()).format(
            "MMM D, YYYY LT"
          )
        );
      }
      if (checkInDetails['InLocation'] && checkInDetails['InLocationName'] !== "NA") {
        checkInDetails['InLocationName'] = this.locations.find(loc => loc.value === checkInDetails['InLocation']).label;
      } else {
        checkInDetails['InLocationName'] = "NA";
      }
      if (checkInDetails['OutLocation'] && checkInDetails['InLocationName'] !== "NA") {
        checkInDetails['OutLocationName'] = this.locations.find(loc => loc.value === checkInDetails['OutLocation']).label;
      } else {
        checkInDetails['OutLocationName'] = "NA";
      }
    });
    if (passRequestData.PassType === 'Employee') {
      this.passRequestFromDate = null;
      this.expiryDate = null;
    } else {
      this.passRequestFromDate = passRequestData.PassRequestFromDate;
      this.expiryDate = passRequestData.PassRequestToDate;
    }
    this.displayPopUp = true;
  }
  getCheckInCheckOutOverviewData() {
    if(this.RedirectFromDashboard == 1)
    {
      this.reset(true);
      const filter = JSON.parse(this.baseService.getFilterData('dashboardFilter'));
      if(filter)
      {
        this.observationFromDate = new Date(filter.Model.FromDateForOverview);
        this.observationToDate = new Date(filter.Model.ToDateForOverview);
        this.passRequestOverviewFilter.FromDate = this.baseService.getUTCDate(this.observationFromDate,true);
        this.passRequestOverviewFilter.ToDate =this.baseService.getUTCDate(this.observationToDate,false);
      }
    }
    this.baseService.showRootLoader = true;
    if (!this.rowCount) {
      this.rowCount = this.itemPerPage * 2;
    }
    this.passRequestOverviewFilter.UserId = this.loggedInUserJSON.UserId;
    this.passRequestOverviewFilter.PageSize = this.itemPerPage;
    if (!this.passRequestOverviewFilter.PageIndex) {
      this.passRequestOverviewFilter.PageIndex = 0;
    }
    this.passRequestOverviewFilter.OrderdByColoumName =
      InspectionConstantsService.ColumnConstants.POBListDate;
    if (!this.passRequestOverviewFilter.OrderdBy) {
      this.passRequestOverviewFilter.OrderdBy =
        InspectionConstantsService.ColumnConstants.DESC;
    }
    if (!this.selectedLocation.length) {
      for (let index = 0; index < this.locations.length; index++) {
        this.selectedLocation.push(this.locations[index].value);
      }
    }
    if (!this.selectedCheckinLocation.length) {
      for (let index = 0; index < this.locations.length; index++) {
        this.selectedCheckinLocation.push(this.locations[index].value);
      }
    }
    if (!this.selectedUnit.length) {
      for (let index = 0; index < this.unitList.length; index++) {
        this.selectedUnit.push(this.unitList[index].value);
      }
    }
    if (!this.selectedStatus.length) {
      this.statuses.forEach(element => {
        this.selectedStatus.push(element.value);
      });
    }
    if(this.ResetOrDone)
    {
      this.pageSize = 1;
      this.passRequestOverviewFilter.PageIndex = 0;
    }
    this.passRequestOverviewFilter.StatusId = this.selectedStatus;
    this.passRequestOverviewFilter.Locations = this.selectedLocation;
    this.passRequestOverviewFilter.CheckinLocations = this.selectedCheckinLocation;
    this.passRequestOverviewFilter.Units = this.selectedUnit;
    this.passRequestOverviewFilter.SelectAll = this.isPassRequestsChecked;
    this.passRequestOverviewFilter.PassType = this.selectedPassType;
    this.passRequestOverviewFilter.CurrentPage = !this.pageSize ? 1 : this.pageSize;
    const filter = JSON.parse(
      this.baseService.getItemFromSession("pobListFilter")
    );
    if (!this.searchModified && filter) {
      this.passRequestOverviewFilter = filter;
      this.pageSize = this.passRequestOverviewFilter.PageIndex;
      this.itemPerPage = this.passRequestOverviewFilter.PageSize;
      this.selectedLocation = this.passRequestOverviewFilter.Locations;
      this.selectedCheckinLocation = this.passRequestOverviewFilter.CheckinLocations;
      this.selectedUnit = this.passRequestOverviewFilter.Units;
      this.selectedStatus = this.passRequestOverviewFilter.StatusId;
      this.isPassRequestsChecked = this.passRequestOverviewFilter.SelectAll;
      this.selectedPassType = this.passRequestOverviewFilter.PassType;
      if (this.pageSize === 0) {
        this.passRequestOverviewFilter.PageIndex = 0;
      } else {
        this.passRequestOverviewFilter.PageIndex = ((this.pageSize * this.itemPerPage) - this.itemPerPage);
        this.rowCount = ((this.pageSize + 1) * this.itemPerPage);
      }
      if (!this.pobServices.getAllPOBRequests()) {
        this.isPassRequestsChecked = true;
        this.passRequestOverviewFilter.SelectAll = true;
      }
    } else {
      this.baseService.setFilterData(
        "pobListFilter",
        JSON.stringify(this.passRequestOverviewFilter)
      );
    }
    const apiRequest = {
      Model: this.passRequestOverviewFilter
    };
    //console.log(apiRequest);
     
    this.pobservice.getPOBListOverviewDetails(
      apiRequest,
      this.callbackMethodForgetPobListOverviewDetails.bind(this)
    );  
    this.ResetOrDone = false;
  }
  callbackMethodForgetPobListOverviewDetails(response) {
    this.baseService.showRootLoader = false;
    if (response.Success) {
      this.pobListData = response.Result;
      this.pobListData.forEach(element => {
        element.CheckInCheckOutDetails.sort((a, b) => a.UserSessionManagementId > b.UserSessionManagementId ? -1 : 1);
        element.CurrentCheckInLocation = (element.CheckInCheckOutDetails[0].InLocation && this.locations.find(l => l.value == element.CheckInCheckOutDetails[0].InLocation).label) || element.LocationName;
        element.InOrOut = element.CheckInCheckOutDetails[0].InOrOut;
        element.PassRequestFromDate = moment(moment.utc(element.PassRequestFromDate).local()).format('DD/MM/YYYY');
        if (element.PassType === 'Contractor') {
          element.PassRequestToDate = moment(moment.utc(element.PassRequestToDate).local()).format('DD/MM/YYYY');
        } else {
          element.PassRequestToDate = 'NA';
        }
        element.CheckInTime = moment(moment.utc(element.CheckInTime).local()).format('DD/MM/YYYY');
      });
      this.baseService.setItemInSession(
        "offlinePobListData",
        JSON.stringify(this.pobListData)
      );
      if (this.passRequestOverviewFilter.SelectAll && !this.searchModified) {
        this.selectAllPassRequests(this.passRequestOverviewFilter.SelectAll);
      } else if (this.searchModified) {
        this.passRequestOverviewFilter.SelectAll = true;
        this.isPassRequestsChecked = true;
        this.pobServices.setAllPOBRequests([]);
        this.selectAllPassRequests(this.passRequestOverviewFilter.SelectAll);
      }
      else if(this.PageLoad == true)
      {
        this.passRequestOverviewFilter.SelectAll = true;
        this.isPassRequestsChecked = true;
        this.selectAllPassRequests(this.passRequestOverviewFilter.SelectAll);
        this.PageLoad = false;
      } 
      else {
        if (this.pobServices.getAllPOBRequests()) {
          this.pobListData.forEach(element => {
            this.pobServices.getAllPOBRequests().forEach(stored => {
              if (element.PassRequestId === stored) {
                element.Checked = true;
              }
            });
          });
        }
      }
      if (!response.Result || response.Result.length < this.itemPerPage) {
        this.rowCount = this.rowCount - this.itemPerPage;
      }
      if (response.Result.length === 0 && this.passRequestOverviewFilter.PageIndex === 0) {
        this.showPagination = false;
        this.noRecordsMsg = "No Records Found!";
      } else {
        this.showPagination = true;
      }
    }
  }
  changeValueCompany(event, company) {
    this.searchModified = true;
    if (event.target.checked === true) {
      this.selectedCompany = [];
      this.companyList.forEach(element => {
        if (element.CompanyId === company.CompanyId) {
          element.checked = true;
          this.selectedCompany.push(company.CompanyId);
        } else {
          if (element.checked) {
            this.selectedCompany.push(element.CompanyId);
          }
        }
      });
    } else {
      this.selectedCompany = [];
      this.companyList.forEach(element => {
        if (element.checked) {
          this.selectedCompany.push(element.CompanyId);
        }
      });
      this.selectedCompany = [];
      this.companyList.forEach(element => {
        if (element.checked) {
          this.selectedCompany.push(element.CompanyId);
        }
      });
    }
  }
  changeValueLocation(event, location) {
    this.searchModified = true;
    if (event.target.checked === true) {
      this.selectedLocation = [];
      this.locations.forEach(element => {
        if (element.LocationId === location.LocationId) {
          element.checked = true;
          this.selectedLocation.push(location.LocationId);
        } else {
          if (element.checked) {
            this.selectedLocation.push(element.LocationId);
          }
        }
      });
    } else {
      this.selectedLocation = [];
      this.locations.forEach(element => {
        if (element.checked) {
          this.selectedLocation.push(element.LocationId);
        }
      });
      this.selectedLocation = [];
      this.locations.forEach(element => {
        if (element.checked) {
          this.selectedLocation.push(element.LocationId);
        }
      });
    }
  }
  onClickedOutside() {
    this.hideFilter = false;
    if (this.hideFilter === false && this.searchModified === true) {
      this.hideFilter = this.searchModified;
      // this.searchModified = false;
    }
    this.hideSort = false;
  }
  onTabOpen() {
    this.hideFilter = true;
    this.hideSort = true;
  }
  clearSearch() {
    this.ResetOrDone = true;
    if (this.rowCount === 50) {
      this.rowCount = this.rowCount * 2;
    }
    if (this.isOnline) {
      this.searchText = "";
      this.searchModified = true;
      this.passRequestOverviewFilter.SearchText = "";
      this.getCheckInCheckOutOverviewData();
      this.pobServices.setAllPOBRequests([]);
    } else {
      this.getOfflineData();
    }
  }
  doneFilter() {
    this.ResetOrDone = true;
    if (this.rowCount === 50) {
      this.rowCount = this.rowCount * 2;
    }
    if (this.isOnline) {
      this.passRequestOverviewFilter.FromDate = this.baseService.getUTCDate(this.observationFromDate,true);
      this.passRequestOverviewFilter.ToDate =this.baseService.getUTCDate(this.observationToDate,false);
      this.passRequestOverviewFilter.SearchText = this.searchText;
      this.getCheckInCheckOutOverviewData();
      this.pobServices.setAllPOBRequests([]);
      this.searchModified = true;
      this.hideFilter = false;
    } 
    else 
    {
      this.getOfflineData();
    }  
  }

  reset(value: boolean)
  {
    if (this.rowCount === 50) {
      this.rowCount = this.rowCount * 2;
    }
    if (this.isOnline) {
      if(value == true)
      {
        this.ResetOrDone = true;
      }
      this.passRequestOverviewFilter = new DashboardFilter();
      this.selectedUnit = [];
      this.selectedLocation = [];
      this.selectedCheckinLocation = [];
      this.selectedStatus = [];
      this.searchModified = value;
      this.searchText = "";
      this.pobServices.setAllPOBRequests([]);
      this.hideFilter = false;
      this.selectedPassType = [1, 2];
    }
    if(value == true)
    {
    this.RedirectFromDashboard = 0;
    }
  }

  resetValue = (value: boolean) => {
    this.reset(value);
    if (this.isOnline) {
      this.observationFromDate = new Date( new Date().setHours(0, 0, 0, 0));
      this.observationToDate = new Date( new Date().setHours(23, 59, 59, 0));
      this.passRequestOverviewFilter.FromDate = this.baseService.getUTCDate(this.observationFromDate,true);
      this.passRequestOverviewFilter.ToDate =this.baseService.getUTCDate(this.observationToDate,false);
      this.getCheckInCheckOutOverviewData();
    } else {
      this.getOfflineData();
    }
  };

  searchData() {
    this.ResetOrDone = true;
    if (this.rowCount === 50) {
      this.rowCount = this.rowCount * 2;
    }
    if(this.searchText != "")
    {
      this.rowCount = 100;
    }
    if (this.isOnline) {
      this.passRequestOverviewFilter.SearchText = this.searchText;
      this.searchModified = true;
      this.getCheckInCheckOutOverviewData();
      this.pobServices.setAllPOBRequests([]);
    } else {
      this.getOfflineData();
    }
  }
  exportToExcel() {
    this.disableExport = true;
    this.notificationsService.toastNotify('info', 'Information Message', 'Downloading is in progress!');
    if (this.isOnline) {
      const filter = JSON.parse(
        this.baseService.getFilterData("pobListFilter")
      );
      filter.SourceIds = [];
      this.pobServices.getAllPOBRequests().forEach(element => {
        filter.SourceIds.push(element);
      });
      const apiRequest = {
        Model: filter
      };
      this.pobServices.exportToExcelPOBRequests(
        apiRequest,
        this.callbackMethodForExportToExcelPOBRequests.bind(this)
      );
    } else {
      this.getOfflineData();
    }
  }
  getUnits() {
    const apiRequestUnit = {
      Model: {
        ModuleId: 0,
        UserId: this.loggedInUserJSON.UserId,
        IsActive : 0
      }
    };
    this.masterscreenService.getUnits(
      apiRequestUnit,
      this.callbackMethodForUnitDetails.bind(this)
    );
  }
  callbackMethodForUnitDetails(response) {
    if (response.Success) {
      this.selectedUnit = [];
      const unitDetails = response.Result;
      this.baseService.setItemInSession(
        "offlineUnits",
        JSON.stringify(unitDetails)
      );
      this.unitList = [];
      unitDetails.forEach(unit => {
        unit.checked = true;
        this.unitList.push({
          label: unit.UnitName,
          value: unit.UnitId,
          checked: true
        });
        this.selectedUnit.push(unit.UnitId);
      });
    }
    this.getLocation();
  }
  closePopUp() {
    this.displayPopUp = false;
  }
  getServerData(event) {
    if (this.isOnline) {
      this.pobServices.setcurrentPersonOnBoardPageIndex(event);
      if (event === 1) {
        this.passRequestOverviewFilter.PageIndex = 0;
      } else {
        this.passRequestOverviewFilter.PageIndex =
          event * this.itemPerPage - this.itemPerPage;
        this.rowCount = (event + 1) * this.itemPerPage;
      }
      this.pageSize = event;
      this.searchModified = true;
      this.getCheckInCheckOutOverviewData();
    } else {
      this.getOfflineData();
    }
  }
  onYesClickedForConfirmation() { }
  onNoClickedForConfirmation() { }
  onOkClicked() { }
  selectPassRequests(passRequest, event) {
    let passRequests = [];
    passRequests = this.pobServices.getAllPOBRequests() ? this.pobServices.getAllPOBRequests() : [];
    if (event.target.checked) {
      passRequests.push(passRequest.PassRequestId);
      if (passRequests.length === this.pobListData.length) {
        this.isPassRequestsChecked = true;
      }
    } else {
      this.isPassRequestsChecked = false;
      this.passRequestOverviewFilter.SelectAll = this.isPassRequestsChecked;
      for (let index = 0; index < passRequests.length; index++) {
        const element = passRequests[index];
        if (passRequest.PassRequestId === element) {
          passRequests.splice(index, 1);
          break;
        }
      }
    }
    this.baseService.setFilterData(
      "pobListFilter",
      JSON.stringify(this.passRequestOverviewFilter)
    );
    this.pobServices.setAllPOBRequests(passRequests);
  }
  downloadZIP() {
    this.disableExport = true;
    if (this.isOnline) {
      this.notificationsService.toastNotify(
        "info",
        "Information Message",
        "Downloading is in progress!"
      );
      const pobList = [];
      this.pobServices.getAllPOBRequests().forEach(element => {
        pobList.push({
          ProcessName: "POB",
          SourceId: element
        });
      });
      if (pobList.length > 0) {
        const apiRequest = {
          Model: {
            SourceIds: pobList
          }
        };
        this.pobServices.downloadZIP(
          apiRequest,
          this.callbackMethodForDownloadZIP.bind(this)
        );
      }
    } else {
      this.getOfflineData();
    }
  }
  callbackMethodForDownloadZIP(response) {
    if (response) {
      //Here assign the Byte array returned from API to data variable
      var fileDownLoadName = "zip_person_on_board.zip"; //Here we can assign name of the document
      FileUtility.downloadPDF(response, fileDownLoadName);
    }
    else{
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Something Went Wrong."
      );
    }
    this.disableExport = false;
  }
  selectAllPassRequests(checked) {
    let selectedPassRequests = [];
    this.pobListData.forEach(element => {
      if (checked) {
        element.Checked = true;
        selectedPassRequests = this.pobServices.getAllPOBRequests();
        if (!selectedPassRequests) {
          selectedPassRequests = [];
        }
        selectedPassRequests.push(element.PassRequestId);
        this.pobServices.setAllPOBRequests(selectedPassRequests);
      } else {
        element.Checked = false;
        this.pobServices.setAllPOBRequests([]);
      }
    });
    this.passRequestOverviewFilter.SelectAll = this.isPassRequestsChecked;
    this.baseService.setFilterData(
      "pobListFilter",
      JSON.stringify(this.passRequestOverviewFilter)
    );
  }
  highlightCurrentSelectedObservation(id) {
    var el = document.getElementById(id);
    while (!this.checked && el !== null) {
      this.checked = true;
      el.scrollIntoView({ behavior: "smooth", block: "center" });
      let currentColor = document.getElementById(id).style.backgroundColor;
      if (currentColor !== null && currentColor !== "darkgray") {
        document.getElementById(id).style.backgroundColor = "darkgray";
      }
      el = null;
    }
  }
  getCurrentDOMElementId(id) {
    this.pobServices.setcurrentPersonOnBoardRequestId(id);
    let passRequests = this.pobServices.getAllPassRequests();
    this.pobListData.forEach(element => {
      if (element.PassRequestId === id) {
        passRequests.push(element);
        return;
      }
    });
    this.pobServices.setAllPassRequests(passRequests);
  }
  ngAfterViewChecked() {
    let currentPassRequestId = this.pobServices.getcurrentPersonOnBoardRequestId();
    if (currentPassRequestId) {
      this.highlightCurrentSelectedObservation(currentPassRequestId);
    }
  }
  callbackMethodForExportToExcelPOBRequests(response) {
    if (response) {
      //Here assign the Byte array returned from API to data variable
      var fileDownLoadName = "Daily POB Export" + new Date().toDateString().replace(':', '_') + ".xlsx"; //Here we can assign name of the document
      FileUtility.downloadPDF(response, fileDownLoadName);
    }
    else{
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Something Went Wrong."
      );
    }
    this.disableExport = false;
  }
}
